import React from "react";
import { FormGroup, Modal, ModalHeader, ModalFooter } from "reactstrap";
import SpinnerButton from "../../../components/Button";

function ConfirmModal({ toggle, handleSubmitArea }) {
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <FormGroup>
        <ModalHeader toggle={toggle}> Desea confirmar los cambios? </ModalHeader>
        <ModalFooter>
          <div className="mb-0 px-3 w-100 d-flex justify-content-between">
            <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <SpinnerButton className="btn btn-primary" type="button" onClick={handleSubmitArea}>
              Confirmar
            </SpinnerButton>
          </div>
        </ModalFooter>
      </FormGroup>
    </Modal>
  );
}

export default ConfirmModal;
